import { createContext, useContext } from 'react';

/** A staff member as shown on chart entries: "Jane Doe, LVN" */
export interface StaffMember {
  userId: string;
  name: string;
  /** Provider type / credentials (RN, LVN, HHA, PT ...) */
  credentials: string | null;
  /** False for a former care team member */
  active?: boolean;
}

/**
 * Phase 18 M5: resolves entry authors (and F21 supervised staff) from the patient's care team,
 * the signed-in user and, when loaded, the tenant's users.
 */
export interface StaffDirectory {
  /** Care team members of the patient (with the signed-in user) */
  careTeam: StaffMember[];
  /** Tenant staff, once `loadTenantStaff` ran (empty when not allowed) */
  tenantStaff: StaffMember[];
  resolve: (userId: string | null | undefined) => StaffMember | undefined;
  loadTenantStaff: () => Promise<StaffMember[]>;
}

export const StaffDirectoryContext = createContext<StaffDirectory | null>(null);

export const useStaffDirectoryContext = (): StaffDirectory | null => useContext(StaffDirectoryContext);

/** "Jane Doe, LVN" (name only when there are no credentials) */
export const formatStaff = (member: StaffMember | undefined | null): string =>
  member ? (member.credentials ? `${member.name}, ${member.credentials}` : member.name) : '';
